export default "__VITE_ASSET__6Gv99qHd__"